import styled from 'styled-components';

import { Wrapper as SectionWrapper } from 'components/CurrencyExchangeTable/styles';

export const Content = styled.div`
  width: 100%;
`;

export const Wrapper = styled.header`
  background-color: #fff;
  width: 100%;
`;

export const ArchiveSection = styled(SectionWrapper)`
  margin-top: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
